import api from '../api';
let apiUrl = 'abonnements';

const state = {
    data: []
};

const actions = {
    index: async ({ commit }, config) => {
        return await api
            .get(`/api/v1/${apiUrl}`, config)
            .then((response) => {
                response.config.params?.key ? commit('setByKey', response) : commit('set', response);

                return response.data;
            })
            .catch((error) => {
                console.error(error);
                return Promise.reject(error);
            });
    },
    show: async ({ commit }, id, config) => {
        return await api
            .get(`/api/v1/${apiUrl}/${id}`, config)
            .then((response) => {
                response.config.params?.key ? commit('replaceByKey', response) : commit('replace', response);
                return response.data;
            })
            .catch((error) => {
                console.error(error);
                return Promise.reject(error);
            });
    },
    upgradeProducts: async ({ commit }, id, config) => {
        return await api
            .get(`/api/v1/${apiUrl}/upgradeProducts/${id}`, config)
            .then((response) => {
                response.config.params?.key ? commit('replaceByKey', response) : commit('replace', response);
                return response.data;
            })
            .catch((error) => {
                console.error(error);
                return Promise.reject(error);
            });
    },
    cancel: async ({ commit }, id) => {
        return await api
            .delete(`/api/v1/${apiUrl}/${id}/cancel`)
            .then((response) => {
                return response.data;
            })
            .catch((error) => {
                console.error(error);
                return Promise.reject(error);
            });
    },
    resume: async ({ commit }, id) => {
        return await api
            .put(`/api/v1/${apiUrl}/${id}/resume`)
            .then((response) => {
                return response.data;
            })
            .catch((error) => {
                console.error(error);
                return Promise.reject(error);
            });
    },
    update: async ({ commit }, { id, data }) => {
        return await api
            .put(`/api/v1/${apiUrl}/${id}`, data)
            .then((response) => {
                commit('replace', response.data);
                return response.data;
            })
            .catch((error) => {
                console.error(error);
                return Promise.reject(error);
            });
    },
    changeRegion: async ({ commit }, id, region) => {
        return await api
            .put(`/api/v1/${apiUrl}/${id}/change-region`, { region: region })
            .then((response) => {
                return response.data;
            })
            .catch((error) => {
                console.error(error);
                return Promise.reject(error);
            });
    },
    cancelRegionChange: async ({ commit }, id) => {
        return await api
            .put(`/api/v1/${apiUrl}/${id}/cancel-region-change`)
            .then((response) => {
                return response.data;
            })
            .catch((error) => {
                console.error(error);
                return Promise.reject(error);
            });
    }
};

const mutations = {
    replace(state, data) {
        let index = state.data.findIndex((item) => item.id === data.id);
        state.data[index] = data;
    },
    replaceByKey(state, response) {
        let index = state.data[response.config.params.key].findIndex((item) => item.id === response.data.id);
        state.data[response.config.params.key][index] = data;
    },
    set(state, data) {
        state.data = data.data;
    },
    setByKey(state, response) {
        let key = response.config.params.key;

        if (state.data.hasOwnProperty(key)) {
            state.data[key].meta = response.data.meta;
            state.data[key].links = response.data.links;

            // only append if append_to_list is true
            response.data.data.length
                ? response.config.params?.page && response.config.params?.append_to_list
                    ? state.data[key].data.push(...response.data.data)
                    : (state.data[key].data = response.data.data)
                : (state.data[key].data = []);
        } else {
            state.data[key] = response.data;
        }
    }
};

const getters = {
    get: (state) => {
        return state.data;
    },
    getById: (state) => (id) => {
        return state.data.find((item) => item.id === id);
    },
    getMeta: (state) => {
        return state.meta;
    },
    getByKey: (state) => (key) => {
        if (state.data && state.data.hasOwnProperty(key)) {
            return state.data[key];
        } else {
            return {
                data: null,
                meta: null,
                links: null
            };
        }
    }
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
};
